import { Injectable } from '@angular/core';
import { bikeOption, busOption, walkOption } from '@features/planification-map/components/route-form/components/route-form-options-panels/components/route-form-more-options/constants';
import { Itinerary, Step } from '@features/planification-map/components/route-form/models/routeRequestResults.model';
import { LegDescription, StepDescription } from '../models';

const HAS_TO_TURN_ON = ['RIGHT', 'LEFT', 'UTURN_LEFT', 'UTURN_RIGHT', "HARD_RIGHT", "HARD_LEFT", "SLIGHTLY_RIGHT", "SLIGHTLY_LEFT"];

const IS_PREFIX = ['DEPART', 'CIRCLE_CLOCKWISE', 'CIRCLE_COUNTERCLOCKWISE'];

const KNOWN_BOGUS_NAMES = ['bike path', 'track', 'link', 'steps',
 'path', 'sidewalk', 'road', 'service road', 'parking aisle', 'default_level', 'alley', 'elevator']

@Injectable({
  providedIn: 'root'
})
export class ResultsFooterService {

  public getLegsDescriptionsFromItinerary(itinerary: Itinerary, origin: string, destination: string): LegDescription[] {
    const legsDescription: LegDescription[] = [];

    itinerary.legs.forEach((leg, index) => {

      const steps:StepDescription[] = []
      if(leg.steps.length > 0) {
        leg.steps.forEach((step, index) => {
          const stepDescription: StepDescription = {
            from: leg.from.name === 'Origin' ? origin : leg.from.name,
            to: leg.to.name === 'Destination' ? destination : leg.to.name,
            bogusName: step.bogusName,
            knownBogusName: step.bogusName && KNOWN_BOGUS_NAMES.includes(step.streetName),
            prefix: this.getPreffix(step),
            action: step.relativeDirection,
            exit: step.exit,
            mode: leg.mode,
            streetName: step.streetName,
            haveToTurnOn: this.stepHasToTurnOn(step),

          }
          steps.push(stepDescription);
        });
      }
      const intermediateStops = leg.intermediateStops ? leg.intermediateStops?.map(stop => stop.name) : [];

      const legDescription: LegDescription = {
        mode: leg.mode,
        modeIcon: this.getIcon(leg.mode),
        intermediateStops: intermediateStops,
        fromIcon: leg.from.name === 'Origin' ? 'aFrom' : 'midStep', //midStep
        toIcon: 'bTo',
        steps: steps,
        duration: leg.duration,
        startHour: leg.startTime,
        endHour: leg.endTime,
        from: leg.from.name === 'Origin' ? origin : leg.from.name,
        to: leg.to.name === 'Destination' ? destination : leg.streetName,
        routeColor: leg.routeColor,
        routeShortName: leg.routeShortName,
        route: leg.route
      }

      legsDescription.push(legDescription);
    });
    



    return legsDescription;
  }

  private getPreffix(step: Step) {
    return IS_PREFIX.includes(step.relativeDirection) ? step.relativeDirection : '';
  }

  private getIcon(mode:string) {
    if (mode === 'BUS') return busOption.id;
    if (mode === 'BICYCLE') return bikeOption.id;
    return walkOption.id;
  }

  private stepHasToTurnOn(step: Step) {
    return HAS_TO_TURN_ON.includes(step.relativeDirection);
  }


}
